import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import InvalidRecipientsTable from './InvalidRecipientsTable';

const CommunicationInvalidRecipientsSection: FC = () => {
  const { t } = useTranslate();

  return (
    <div className="table-recipients m-0">
      <div className="d-flex flex-column">
        <h6 className="m-0">{t('InvalidRecipients')}</h6>
        <span className="text-soft mt-2 lh-18px d-flex align-items-end">
          <em className="icon ni ni-alert-circle mr-1 fs-18px" />
          {t('InvalidRecipientsDescription')}
        </span>
      </div>

      <div className="card card-bordered mt-3">
        <InvalidRecipientsTable />
      </div>
    </div>
  );
};

export default CommunicationInvalidRecipientsSection;
